/* =========================================================================
   Upgreens: allgemeine Ergaenzungen.

   Wird in layout/theme.liquid geladen, direkt neben upgreens.css. Alles,
   was NICHT zu einer bestimmten Sektion gehoert, kommt hierhin — sonst
   entstehen fuer Kleinigkeiten immer neue Dateien.

   AKTUELL:
     - Produktbeschreibung ein-/ausklappbar
   ========================================================================= */
(function () {
  'use strict';

  /* ---- Produktbeschreibung ein-/ausklappbar -----------------------------
     Die Beschreibung ist fuer Suchmaschinen und Sprachmodelle wertvoll, auf
     der Seite aber oft eine Textwand. Sie bleibt deshalb VOLLSTAENDIG im
     Dokument und wird nur optisch beschnitten — kein Nachladen, kein
     Ausblenden per display:none, das wuerde den Text fuer Google entwerten.

     Der Knopf erscheint nur, wenn der Text tatsaechlich laenger ist als der
     sichtbare Ausschnitt. Bei drei Zeilen Beschreibung waere er Unsinn.
     ---------------------------------------------------------------------- */

  // Aus snippets/ug-texte.liquid, damit Translate & Adapt sie erreicht.
  // Fehlt das Snippet, bleibt der deutsche Text.
  var BESCHRIFTUNG_AUF = window.ugText ? window.ugText('beschreibung_mehr', 'Mehr lesen') : 'Mehr lesen';
  var BESCHRIFTUNG_ZU = window.ugText ? window.ugText('beschreibung_weniger', 'Weniger anzeigen') : 'Weniger anzeigen';

  function beschreibungFalten(el) {
    if (el.dataset.ugGefaltet) return;

    // Erst messen, dann entscheiden: lohnt das Falten ueberhaupt?
    var volleHoehe = el.scrollHeight;
    el.classList.add('ug-rte--gefaltet');
    var sichtbar = el.clientHeight;

    if (volleHoehe <= sichtbar + 8) {
      // Passt ohnehin — Klasse wieder weg, kein Knopf
      el.classList.remove('ug-rte--gefaltet');
      return;
    }

    el.dataset.ugGefaltet = '1';
    el.setAttribute('aria-expanded', 'false');

    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'ug-rte__schalter';
    knopf.textContent = BESCHRIFTUNG_AUF;
    knopf.setAttribute('aria-controls', el.id || '');

    knopf.addEventListener('click', function () {
      var offen = el.classList.toggle('ug-rte--offen');
      el.classList.toggle('ug-rte--gefaltet', !offen);
      el.setAttribute('aria-expanded', offen ? 'true' : 'false');
      knopf.textContent = offen ? BESCHRIFTUNG_ZU : BESCHRIFTUNG_AUF;

      // Beim Zuklappen zurueck zum Anfang, sonst steht man im Nichts
      if (!offen) {
        var oben = el.getBoundingClientRect().top;
        if (oben < 0) el.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    });

    el.insertAdjacentElement('afterend', knopf);
  }

  function start() {
    document.querySelectorAll('.product__description').forEach(beschreibungFalten);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Der Theme-Editor baut Sektionen neu auf
  document.addEventListener('shopify:section:load', start);
})();

/* =========================================================================
   Wisch-Hinweis fuer "Mehrspaltig"

   Eingeschaltet ueber die Sektions-Einstellung "Wisch-Hinweis auf dem Handy"
   (00_tools/schritte-hinweis.js), die die Klasse `ug-wischhinweis` setzt.

   WARUM ueberhaupt:
   Motto zeigt unter der Reihe Punkte an. Die sieht aber nur, wer schon
   weiss, dass es weitergeht — und wer das weiss, braucht sie nicht. Eine
   kurze Bewegung beim ersten Sichtbarwerden zeigt es, statt es zu sagen.

   WARUM UEBER SWIPER STATT PER CSS:
   Die Reihe wird von Swiper bewegt; Swiper schreibt dabei `transform` auf
   den Wrapper. Eine eigene CSS-Animation auf demselben Element wuerde
   dagegen laufen und beim ersten Wischen sichtbar springen. Ueber
   `translateTo` benutzen wir Swipers eigene Mechanik — es ist dieselbe
   Bewegung, die auch ein echter Wisch ausloest.

   Nur einmal je Seitenaufruf, nur auf dem Handy, und nicht bei
   `prefers-reduced-motion`.
   ========================================================================= */
(function () {
  'use strict';

  var WEG = 96; // Pixel, die angeschoben wird
  var HIN = 640; // Millisekunden hin
  var HALTEN = 260; // kurz stehen bleiben, damit die Bewegung ankommt
  var ZURUECK = 860; // ... und gemaechlicher zurueck

  function anschieben(liste) {
    var sw = liste.swiper;
    if (!sw || sw.destroyed || typeof sw.translateTo !== 'function') return;
    if (sw.slides && sw.slides.length < 2) return;

    var start = sw.translate;

    // `translateBounds: false` — sonst zieht Swiper die Bewegung sofort
    // wieder auf den erlaubten Bereich zurueck und man sieht nichts.
    sw.translateTo(start - WEG, HIN, false, false);

    setTimeout(function () {
      sw.translateTo(start, ZURUECK, false, false);
    }, HIN + HALTEN);
  }

  function start() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    if (typeof IntersectionObserver !== 'function') return;

    document.querySelectorAll('.multicolumn-list.ug-wischhinweis.swiper').forEach(function (liste) {
      if (liste.dataset.ugGewischt) return;

      var beobachter = new IntersectionObserver(
        function (eintraege) {
          eintraege.forEach(function (e) {
            if (!e.isIntersecting) return;
            beobachter.disconnect();
            if (liste.dataset.ugGewischt) return;
            liste.dataset.ugGewischt = '1';
            // Kurz warten: Swiper braucht einen Moment, und mitten in die
            // Scrollbewegung hinein wirkt der Hinweis wie ein Ruckler.
            setTimeout(function () {
              anschieben(liste);
            }, 260);
          });
        },
        // Ausloeser: die OBERKANTE der Reihe erreicht die Bildschirmmitte.
        // `rootMargin` zieht den unteren Rand des Beobachtungsbereichs um die
        // halbe Fensterhoehe nach oben — damit faengt die Ueberschneidung
        // genau in der Mitte an. Ueber `threshold` waere das nicht zu machen:
        // ein Schwellwert misst, WIE VIEL des Elements zu sehen ist, nicht
        // WO es steht. Bei unterschiedlich hohen Reihen loest derselbe
        // Schwellwert an unterschiedlichen Stellen aus.
        { rootMargin: '0px 0px -50% 0px', threshold: 0 }
      );

      beobachter.observe(liste);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();

/* =========================================================================
   Wisch-Hinweis fuer unsere Kartenreihen (Samen auf der Produktseite und
   im Warenkorb).

   WARUM EIN ZWEITER BLOCK:
   Der Hinweis darueber bewegt Mottos Mehrspalter, und der laeuft ueber
   Swiper. Unsere Kartenreihe `.ug-karten` ist kein Swiper, sondern ein
   gewoehnlicher Scrollbereich mit Einrastpunkten. `translateTo` gibt es
   dort nicht, also wird hier `scrollLeft` bewegt.

   WARUM NICHT `scrollTo({ behavior: 'smooth' })`:
   Dann bestimmt der Browser die Dauer, und die ist je nach Geraet eine
   andere. Der Hinweis auf der Startseite dauert 640ms hin und 860ms
   zurueck. Damit sich beide gleich anfuehlen, wird hier mit denselben
   Werten selbst bewegt.

   Nur einmal je Reihe und Seitenaufruf, nur auf dem Handy, nicht bei
   `prefers-reduced-motion`, und nur wenn es ueberhaupt etwas zu wischen
   gibt. Wer schon selbst gescrollt hat, bekommt ihn nicht mehr.
   ========================================================================= */
(function () {
  'use strict';

  var WEG = 96; // Pixel, die angeschoben wird
  var HIN = 640; // Millisekunden hin
  var HALTEN = 260; // kurz stehen bleiben, damit die Bewegung ankommt
  var ZURUECK = 860; // ... und gemaechlicher zurueck

  function schieben(reihe, von, nach, dauer, fertig) {
    var beginn = null;
    function schritt(jetzt) {
      if (beginn === null) beginn = jetzt;
      var p = Math.min(1, (jetzt - beginn) / dauer);
      // Weiche Kurve: langsam an, langsam aus. Linear sieht mechanisch aus.
      var e = p < 0.5 ? 2 * p * p : -1 + (4 - 2 * p) * p;
      reihe.scrollLeft = von + (nach - von) * e;
      if (p < 1) requestAnimationFrame(schritt);
      else if (fertig) fertig();
    }
    requestAnimationFrame(schritt);
  }

  function anschieben(reihe) {
    // Passt alles ins Bild, gibt es nichts zu zeigen.
    if (reihe.scrollWidth - reihe.clientWidth < WEG) return;
    // Hat jemand schon selbst gewischt, waere der Hinweis eine Bevormundung.
    if (reihe.scrollLeft > 4) return;

    // Die Einrastpunkte fuer die Dauer des Hinweises abschalten.
    //
    // WARUM: Die Reihe hat `scroll-snap-type: x mandatory`. Der Browser zieht
    // jede gesetzte Position sofort auf die naechste Karte zurueck. Gemessen
    // sah der Hinweis deshalb so aus: 725ms lang gar nichts, dann ein Sprung
    // auf 169px (die naechste Karte), dann zurueck. Also ein Ruckler statt
    // einer Bewegung — schlechter als kein Hinweis.
    //
    // Danach wird der eigene Stil wieder entfernt, nicht auf einen Wert
    // gesetzt: sonst stuende hier eine zweite Wahrheit neben dem Stylesheet.
    reihe.style.scrollSnapType = 'none';

    schieben(reihe, 0, WEG, HIN, function () {
      setTimeout(function () {
        schieben(reihe, WEG, 0, ZURUECK, function () {
          reihe.style.removeProperty('scroll-snap-type');
        });
      }, HALTEN);
    });
  }

  function start() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    if (typeof IntersectionObserver !== 'function') return;

    document.querySelectorAll('.ug-karten').forEach(function (reihe) {
      if (reihe.dataset.ugGewischt) return;

      var beobachter = new IntersectionObserver(
        function (eintraege) {
          eintraege.forEach(function (e) {
            if (!e.isIntersecting) return;
            beobachter.disconnect();
            if (reihe.dataset.ugGewischt) return;
            reihe.dataset.ugGewischt = '1';
            // Kurz warten, damit der Hinweis nicht mitten in die eigene
            // Scrollbewegung faellt und wie ein Ruckler wirkt. Vorher 260ms:
            // zusammen mit dem spaeteren Ausloeser kam die Bewegung zu spaet,
            // man hatte da schon weitergescrollt.
            setTimeout(function () {
              anschieben(reihe);
            }, 150);
          });
        },
        // Ausloeser: die Oberkante der Reihe erreicht das untere Viertel des
        // Bildschirms. Der Hinweis auf der Startseite wartet bis zur Mitte;
        // dort steht die Reihe allein, hier steckt sie im Kaufblock und ist
        // beim Erreichen der Mitte laengst vorbeigescrollt.
        { rootMargin: '0px 0px -25% 0px', threshold: 0 }
      );

      beobachter.observe(reihe);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);

  // Die Reihe im Warenkorb entsteht erst, wenn die Schublade sich neu
  // zeichnet. Ohne das bekaeme sie den Hinweis nie.
  if (window.subscribe && window.PUB_SUB_EVENTS) {
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(start, 400);
    });
  }
})();

/* === Die Schere liegt bei, sie liegt nicht im Korb ========================

   BIS ZUM 13.10.2026 legte dieser Block die Praezisionsschere als eigene
   Zeile in den Warenkorb, ein automatischer Rabatt (Buy X Get Y) zog sie
   auf 0 EUR.

   WARUM DAS WEG IST: Shopify feuert `product_added_to_cart` fuer JEDE
   Zeile, die im Browser angelegt oder erhoeht wird, gleich ueber welchen
   Endpunkt. Am 13.10.2026 direkt an `fbq` mitgeschrieben:

     /cart/add       (Geraet)    ->  AddToCart Kitchenforest   199 EUR
     /cart/update.js (Schere)    ->  AddToCart Schere           12 EUR
     /cart/change    (Menge +1)  ->  AddToCart Kitchenforest   199 EUR
     /cart/change.js (Schere)    ->  AddToCart Schere           12 EUR

   Meta zaehlte also zwei Zulagen pro Klick, mit 12 EUR im Wert und der
   Schere als eigenem Produkt im Katalog. Beides in eine Anfrage zu
   verschmelzen half nicht, und ueber `update.js` nachzulegen auch nicht:
   es haengt an der ZEILE, nicht am Endpunkt.

   WAS JETZT PASSIERT: der Kitchenforest geht allein in den Korb und
   traegt die Schere als Eigenschaft an seiner Zeile ("Beilage:
   Praezisionsschere"). Eine Zeile, ein Ereignis. Die Eigenschaft steht im
   Korb, im Checkout und auf der Bestellung, das Lager sieht sie also.

   WOHER DIE VARIANTEN KOMMEN: aus `window.ugBeilage`, gesetzt in
   snippets/ug-texte.liquid aus Liquid heraus. Kein `fetch` auf
   /products/*.js mehr, das verzoegerte frueher den ersten Klick.

   DER BESTAND: die Schere bleibt ein Produkt mit gezaehltem Bestand, aber
   Shopify bucht ihn nicht mehr ab, weil keine Zeile mehr entsteht. Das
   macht 00_tools/schere-bestand.js einmal taeglich aus den Bestellungen.

   ZUM RUECKBAU gehoeren drei Dinge zusammen: dieser Block, der Rabatt
   "Buy X Get Y" im Admin und 00_tools/schere-bestand.js.
   ========================================================================= */
(function () {
  'use strict';

  /* Die Schere als Produkt. Nur noch fuers Aufraeumen alter Koerbe
     gebraucht, siehe unten. */
  const SCHERE_PRODUKT = 15920691118464;

  function beilage() {
    const b = window.ugBeilage;
    if (!b || !b.name || !b.wert) return null;
    if (!Array.isArray(b.varianten) || !b.varianten.length) return null;
    return b;
  }

  /* Haengt die Eigenschaft an, OHNE das Format der Anfrage anzufassen.
     Mottos Kaufformular schickt FormData, Konfigurator und Kaufabteil
     schicken JSON. Beides bleibt, wie es ist: ein umgebautes Format waere
     eine zweite Fehlerquelle fuer einen Zusatz, der nur danebensteht. */
  function anhaengen(init, b) {
    const koerper = init && init.body;
    const feld = 'properties[' + b.name + ']';

    if (koerper instanceof FormData) {
      if (b.varianten.indexOf(Number(koerper.get('id'))) === -1) return;
      if (koerper.get(feld)) return;
      koerper.append(feld, b.wert);
      return;
    }

    if (typeof koerper !== 'string') return;
    let d;
    try { d = JSON.parse(koerper); } catch (e) { return; }
    const liste = Array.isArray(d.items) ? d.items : [d];
    let geaendert = false;
    liste.forEach(function (a) {
      if (!a || b.varianten.indexOf(Number(a.id)) === -1) return;
      a.properties = Object.assign({}, a.properties);
      if (a.properties[b.name]) return;
      a.properties[b.name] = b.wert;
      geaendert = true;
    });
    if (geaendert) init.body = JSON.stringify(d);
  }

  /* ---- Alte Koerbe aufraeumen -------------------------------------------

     Wer am 13.10.2026 einen Korb offen hatte, hat die Schere noch als
     eigene Zeile darin. Sobald der Rabatt im Admin aus ist, stuenden dort
     12 EUR, die niemand bestellt hat. Deshalb einmal je Seitenaufruf
     nachsehen und die Zeile stillschweigend entfernen.

     NUR ZUSAMMEN MIT EINEM GERAET: wer die Schere allein gekauft hat,
     wollte sie. Entfernen feuert bei Meta nichts, das ist gemessen. */
  const originalFetch = window.fetch;

  async function aufraeumen() {
    const b = beilage();
    if (!b) return;
    try {
      const korb = await originalFetch('/cart.js').then(function (r) { return r.json(); });
      const geraete = korb.items.filter(function (i) {
        return b.varianten.indexOf(Number(i.variant_id)) !== -1;
      }).length;
      if (!geraete) return;

      const zeilen = korb.items
        .map(function (i, n) { return { nr: n + 1, produkt: i.product_id }; })
        .filter(function (z) { return z.produkt === SCHERE_PRODUKT; });
      if (!zeilen.length) return;

      /* Von hinten nach vorn: jedes Entfernen verschiebt die Nummern
         dahinter. */
      for (let k = zeilen.length - 1; k >= 0; k--) {
        await originalFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: zeilen[k].nr, quantity: 0 }),
        });
      }
      await neuZeichnen();
    } catch (e) {
      console.warn('Alte Schere im Korb:', e);
    }
  }

  async function neuZeichnen() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        const namen = drawer.getSectionsToRender().map(function (a) { return a.id; }).join(',');
        const daten = await originalFetch('/?sections=' + namen).then(function (r) { return r.json(); });
        drawer.renderContents({ sections: daten });
        return;
      } catch (e) {
        /* faellt nach unten durch */
      }
    }
    if (/\/cart/.test(window.location.pathname)) window.location.reload();
  }

  window.fetch = async function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';

    let istKonfigurator = false;
    let variantId = null;

    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      const b = beilage();
      if (b) {
        try {
          anhaengen(args[1], b);
        } catch (e) {
          /* Eine fehlende Beilage darf keinen Kauf kosten. */
          console.warn('Beilage:', e);
        }
      }

      try {
        const body = args[1] && args[1].body;

        if (body instanceof FormData) {
          istKonfigurator = body.get('properties[_quelle]') === 'Konfigurator';
          variantId = body.get('id');
        } else if (typeof body === 'string') {
          const d = JSON.parse(body);
          const liste = Array.isArray(d.items) ? d.items : [d];
          const konf = liste.find(function (x) {
            return x && x.properties && x.properties._quelle === 'Konfigurator';
          });
          if (konf) {
            istKonfigurator = true;
            variantId = konf.id;
          }
        }
      } catch (e) {
        // Tracking darf den Warenkorb nicht stoeren.
      }
    }

    const antwort = await originalFetch.apply(this, args);

    // Nur erfolgreicher Konfigurator-Add-to-Cart.
    if (istKonfigurator && antwort.ok) {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        Shopify.analytics.publish('upgreens:configurator_add_to_cart', { variant_id: variantId });
      }
    }

    return antwort;
  };

  document.addEventListener('DOMContentLoaded', aufraeumen);
})();

/* =========================================================================
   „Cookie-Einstellungen" im Fussmenue oeffnet wieder das Banner.

   DAS PROBLEM:
   Der Menuepunkt zeigte auf `/policies/#shopifyReshowConsentBanner`. Den
   Anker braucht Shopify, aber `/policies/` allein gibt es nicht — ein Klick
   landete auf einer 404-Seite. Gefunden mit 00_tools/seite-pruefen.js.

   DIE LOESUNG:
   Shopifys eigenes Banner bringt `window.privacyBanner.showPreferences()`
   mit — nachgesehen im Browser, die Methode gibt es wirklich. Ein Klick auf
   einen Link mit diesem Anker wird hier abgefangen und oeffnet das Banner
   an Ort und Stelle, ohne die Seite zu wechseln.

   WARUM HIER UND NICHT IM MENUE:
   Ein Navigationsmenue kann nur Adressen, keine Handlungen. Und ein Link,
   der nur aus einem Anker besteht, laesst sich dort nicht eintragen. Der
   Menuepunkt bleibt also, wie er ist; was er tut, steht hier.

   UND DER LINK SELBST:
   Laedt dieses Skript einmal nicht, oder folgt eine Suchmaschine dem Link
   ohne JavaScript, fuehrt er weiter ins Leere. Deshalb wird das Ziel beim
   Laden auf die Startseite umgeschrieben — der Anker bleibt daran haengen,
   damit der Klickfaenger oben ihn weiter erkennt.
   ========================================================================= */
(function () {
  'use strict';

  const ANKER = 'shopifyReshowConsentBanner';

  function zielReparieren() {
    document.querySelectorAll('a[href*="' + ANKER + '"]').forEach((a) => {
      if (a.getAttribute('href').indexOf('/policies/#') === 0) {
        a.setAttribute('href', '/#' + ANKER);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', zielReparieren);
  } else {
    zielReparieren();
  }

  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href*="' + ANKER + '"]');
    if (!link) return;

    const banner = window.privacyBanner;
    if (!banner || typeof banner.showPreferences !== 'function') {
      // Ohne Banner-Schnittstelle den Link tun lassen, was er tut.
      return;
    }

    e.preventDefault();
    banner.showPreferences();
  });
})();
/* =========================================================================
   HIER STAND: „Handy: kein Warenkorb-Einschub, direkt zur Warenkorbseite."

   Unter 750px wurde der Klick aufs Korbsymbol abgefangen und auf /cart
   umgeleitet, und `<product-form>` wurde die Schublade vor dem Absenden
   weggenommen. Grund war der Platz: auf einem iPhone 12 mini nahmen die
   Garantiepunkte oben und der feste Fuss mit Samen-Angebot der
   Artikelliste fast alles weg. Dazu fuehrte „Warenkorb anzeigen" in einen
   zweiten, anders aussehenden Warenkorb.

   AM 09.10.2026 ENTFERNT. Das Schubfach ist jetzt auch auf dem Handy der
   Weg zur Kasse. Was dafuer geaendert wurde:

     - Die Zusagen stehen nicht mehr oben, sondern am Kassenknopf
       (00_tools/warenkorb-trust.js). Oben beginnt die Artikelliste.
     - Auf dem Handy scrollt das Schubfach als Ganzes, und nur der
       Knopfblock klebt unten fest (assets/upgreens.css, Abschnitt
       „Das Schubfach auf dem Handy").
     - „Warenkorb anzeigen" ist auf dem Handy ausgeblendet. Das Schubfach
       traegt jetzt alles, was die Seite traegt — Summe, Rabatte,
       Zusagen, Kundenstimme, Zahlungsarten. Zwei Warenkoerbe braucht
       niemand, und der zweite Knopf kostete im festen Fuss am meisten.

   Wer das rueckgaengig machen will, braucht keinen neuen Code: im Theme
   „Warenkorbtyp" von „Schublade" auf „Seite" stellen. Dann gibt es das
   Schubfach ueberall nicht mehr, und zwar in beiden Breiten gleich.
   ========================================================================= */

/* =========================================================================
   Widerrufshinweis im Warenkorb — eine Zeile, kein Haken.

   WARUM:
   Individuell gefertigte Geraete sind vom Widerruf ausgenommen
   (§ 312g Abs. 2 Nr. 1 BGB). Darauf muss VOR der Bestellung aktiv
   hingewiesen werden. Hinweisen, nicht zustimmen lassen: rechtlich beraten
   am 17.10.2026, der Hinweis allein genuegt.

   WAS AM 17.10.2026 WEGGEFALLEN IST:
   Der Kasten mit Titel, Text und Pflichthaken; der gesperrte Kassenknopf;
   die ausgeblendeten Express-Knoepfe; das Warenkorb-Attribut mit
   Zeitstempel; das Einklappen nach dem Haken; das Zuruecksetzen beim
   Schliessen der Schublade. Jeder Schritt zwischen Korb und Kasse kostet
   Kaeufe, und dieser war einer zu viel. Wer die alte Fassung sucht:
   `git log -S ug-widerruf__check`.

   WAS BLEIBT:
   - Erkennung ueber die Produkt-ID von „Made-to-Order Kitchenforest".
     Standardkombinationen landen als normales Kitchenforest-Produkt im
     Korb und loesen nichts aus.
   - Die Zeile steht direkt ueber „Zur Kasse", auf der Warenkorbseite wie
     im Schubfach.
   - Motto baut Warenkorb-Teile nach jeder Aenderung neu auf. Ein
     MutationObserver setzt die Zeile danach wieder ein.
   - Ein Korb, der noch die alte Bestaetigung als Attribut traegt, wird sie
     los. Sonst stuende an einer neuen Bestellung eine Zustimmung, die
     niemand mehr gegeben hat.
   ========================================================================= */
(function () {
  'use strict';

  const KONFIG_PRODUKT_ID = 15923835797888; // Made-to-Order Kitchenforest
  const ATTRIBUT = 'Widerrufshinweis';      // nur noch zum Aufraeumen
  const t = (k, n) => (window.ugText ? window.ugText(k, n) : n);

  let individuell = false;
  let laeuft = false;

  function bauen(reihe) {
    const wurzel = ((window.routes && window.routes.root_url) || '/').replace(/\/$/, '');
    const zeile = document.createElement('p');
    zeile.className = 'ug-widerruf';
    zeile.innerHTML =
      t('widerruf_zeile', 'Individuell gefertigt – ohne Widerrufsrecht.') +
      ' <a href="' + wurzel + '/policies/refund-policy" target="_blank" rel="noopener">' +
      t('widerruf_link', 'Widerrufsbelehrung') + '</a>';
    reihe.parentElement.insertBefore(zeile, reihe);
  }

  function anwenden() {
    document.querySelectorAll('[name="checkout"]').forEach((knopf) => {
      const reihe = knopf.closest('.cart__ctas') || knopf.parentElement;
      const davor = reihe.previousElementSibling;
      const zeile = davor && davor.classList.contains('ug-widerruf') ? davor : null;
      if (individuell && !zeile) bauen(reihe);
      if (!individuell && zeile) zeile.remove();
    });
  }

  function attributLeeren() {
    return fetch(((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { [ATTRIBUT]: '' } }),
    }).catch(() => {});
  }

  async function pruefen() {
    if (laeuft) return;
    laeuft = true;
    try {
      const cart = await fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js').then((r) => r.json());
      individuell = cart.items.some((i) => i.product_id === KONFIG_PRODUKT_ID);
      if (cart.attributes && cart.attributes[ATTRIBUT]) attributLeeren();
      anwenden();
    } catch (e) {
      console.warn('Widerrufshinweis:', e);
    } finally {
      laeuft = false;
    }
  }

  let uhr;
  new MutationObserver(() => { clearTimeout(uhr); uhr = setTimeout(anwenden, 50); })
    .observe(document.body, { childList: true, subtree: true });

  if (window.subscribe && window.PUB_SUB_EVENTS) {
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(pruefen, 300));
  }
  const vorFetch = window.fetch;
  window.fetch = async function (...args) {
    const antwort = await vorFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    if (/\/cart\/(add|change|clear)/.test(url)) setTimeout(pruefen, 400);
    return antwort;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pruefen);
  else pruefen();
})();
/* =========================================================================
   Basilikum und Petersilie: Hinweis „1× inklusive“.

   WARUM:
   Jeder Kitchenforest wird mit Basilikum- und Petersilie-Samen geliefert.
   In der Samenauswahl (Produktseite) und im Warenkorb („Mehr Kräuter
   Kreativität?“) sahen beide aus wie fehlende Extras. Weitere Kits sollen
   aber kaufbar bleiben.

   WIE:
   - Beide Karten rücken nach vorn und bekommen das Etikett „1× inklusive“.
     Anwählen bzw. Hinzufügen funktioniert unverändert: das kauft ein
     WEITERES Kit zum normalen Preis.
   - Produktseite: immer (dort wird der Kitchenforest gekauft).
   - Warenkorb: nur wenn ein Kitchenforest drinliegt.
   - Motto baut den Warenkorb nach jeder Änderung neu auf, deshalb
     MutationObserver.
   ========================================================================= */
(function () {
  'use strict';

  const INKLUSIVE = [58788714873216, 58788980621696]; // Varianten Basilikum, Petersilie
  const KITCHENFOREST = [15899931214208, 15923835797888]; // Produkte Kitchenforest, Made-to-Order
  const t = (k, n) => (window.ugText ? window.ugText(k, n) : n);

  let geraetImKorb = false;

  function etikett(karte, an) {
    const bild = karte.querySelector('.ug-karte__bild');
    if (!bild) return;
    const da = bild.querySelector('.ug-karte__inklusive');
    if (an && !da) {
      const e = document.createElement('span');
      e.className = 'ug-karte__inklusive';
      e.textContent = t('samen_inklusive', '1× inklusive');
      bild.appendChild(e);
    } else if (!an && da) {
      da.remove();
    }
    karte.classList.toggle('ug-karte--inklusive', an);
  }

  // Produktseite: Checkbox + Label als Paar ans ENDE, Etikett dran.
  //
  // Vorher standen sie vorn. Das kehrt die Reihe aber um: die ersten zwei
  // Karten, die jemand sieht, sind dann die beiden, die er ohnehin schon
  // bekommt. Wer hier etwas dazulegen soll, muss zuerst das sehen, was ihm
  // noch fehlt. Also Koriander und Oregano zuerst, die inklusiven zuletzt.
  // Das Etikett bleibt, kaufbar bleiben sie auch — es kauft ein WEITERES Kit.
  function produktseite() {
    document.querySelectorAll('[data-ug-addons] .ug-karten').forEach((reihe) => {
      const felder = [...reihe.querySelectorAll('[data-ug-wahl]')].filter((f) => INKLUSIVE.indexOf(Number(f.value)) !== -1);
      felder.forEach((feld) => {
        const karte = reihe.querySelector('label[for="' + feld.id + '"]');
        if (!karte || karte.classList.contains('ug-karte--inklusive')) return;
        etikett(karte, true);
        reihe.append(feld, karte);
      });
    });
  }

  // Warenkorb: Knöpfe der Kräuter-Empfehlung.
  function warenkorb() {
    document.querySelectorAll('.ug-korb-samen .ug-karten').forEach((reihe) => {
      const knoepfe = [...reihe.querySelectorAll('[data-ug-korb-samen-id]')].filter((k) => INKLUSIVE.indexOf(Number(k.dataset.ugKorbSamenId)) !== -1);
      // Ans Ende, aus demselben Grund wie auf der Produktseite. Danach an
      // den Anfang der Reihe scrollen: dort steht jetzt das, was fehlt.
      let verschoben = false;
      knoepfe.forEach((knopf) => {
        if (knopf.classList.contains('ug-karte--inklusive') === geraetImKorb) return;
        etikett(knopf, geraetImKorb);
        if (geraetImKorb) {
          reihe.append(knopf);
          verschoben = true;
        }
      });
      if (verschoben) reihe.scrollLeft = 0;
    });
  }

  async function korbPruefen() {
    if (!document.querySelector('.ug-korb-samen')) return;
    try {
      const cart = await fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js').then((r) => r.json());
      geraetImKorb = cart.items.some((i) => KITCHENFOREST.indexOf(i.product_id) !== -1);
      warenkorb();
    } catch (e) {
      console.warn('Inklusive-Samen:', e);
    }
  }

  function alles() {
    produktseite();
    warenkorb();
  }

  let uhr;
  new MutationObserver(() => {
    clearTimeout(uhr);
    uhr = setTimeout(alles, 60);
  }).observe(document.body, { childList: true, subtree: true });

  if (window.subscribe && window.PUB_SUB_EVENTS) {
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(korbPruefen, 300));
  }

  function start() {
    produktseite();
    korbPruefen();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* =========================================================================
   Bild-Modal verlassen: nach unten wischen, neben das Bild tippen.

   WARUM:
   Mottos `ProductModal` erbt von `ModalDialog`. Das schliesst auf Klick nur
   dann, wenn der Klick das Modal SELBST trifft (`event.target === this`),
   und beim Bild-Modal trifft er das nie: darin liegt
   `.product-media-modal__dialog` mit 100% Breite und 100vh Hoehe, darunter
   der Swiper. Also fuehrte genau ein Weg hinaus, das X oben rechts.

   WAS JETZT SCHLIESST:
   - Wischen nach unten, ab 70px und eher senkrecht als quer. Quer gehoert
     dem Karussell, das die Bilder durchblaettert.
   - Tippen oder klicken neben das Bild. Auf dem Handy ist das Bild 60%
     hoch (section-main-product.css), darueber und darunter ist Platz.
   - Das Bild selbst nicht: ein Klick darauf schaltet die Lupe (`zoom`,
     main-product.js). Und im Zoom wischt der Finger das Bild, also
     schliesst Wischen dort auch nicht.

   NEBENBEI: die Lupe wird beim Schliessen zurueckgesetzt. Sonst oeffnet
   das naechste Bild vergroessert, weil die Klasse am Inhalt haengen bleibt.

   WARUM HIER UND NICHT IN MOTTO: `main-product.liquid` gehoert Motto und
   waere nach einem Update wieder wie vorher. Von aussen zugehoert kostet
   nichts.
   ========================================================================= */
(function () {
  'use strict';

  const SCHWELLE = 70;   // Pixel nach unten, ab denen geschlossen wird
  const SCHRAEG = 0.8;   // mehr Querweg als das mal Hochweg: Karussell
  const WEGZEIT = 180;   // Millisekunden, die das Hinausgleiten dauert

  const BILDER = 'img, video, iframe, model-viewer, deferred-media, product-model,' +
    ' button, a, input, .swiper-pagination, .swiper-button-next, .swiper-button-prev';

  function zu(modal, gewischt) {
    const inhalt = modal.querySelector('.product-media-modal__content');

    function fertig() {
      modal.classList.remove('ug-modal--weg');
      if (inhalt) inhalt.classList.remove('zoom');
      if (typeof modal.hide === 'function') modal.hide();
      else modal.removeAttribute('open');
    }

    if (gewischt) {
      modal.classList.add('ug-modal--weg');
      setTimeout(fertig, WEGZEIT);
    } else {
      fertig();
    }
  }

  function offenes(el) {
    return el && el.closest ? el.closest('.product-media-modal[open]') : null;
  }

  function imZoom(modal) {
    const inhalt = modal.querySelector('.product-media-modal__content');
    return !!inhalt && inhalt.classList.contains('zoom');
  }

  document.addEventListener('click', (e) => {
    const modal = offenes(e.target);
    if (!modal) return;
    if (e.target.closest(BILDER)) return;
    zu(modal, false);
  });

  /* WARUM DER FINGER EINEN EIGENEN WEG BRAUCHT:
     Der Klickfaenger oben haengt am Dokument. Auf dem iPhone kommt dort
     nichts an, wenn jemand auf eine gewoehnliche Flaeche tippt: Safari
     liefert den Klick nur fuer Elemente, die von Haus aus anklickbar sind
     oder `cursor: pointer` tragen. Die weisse Flaeche ueber und unter dem
     Bild ist beides nicht — auf dem Rechner schloss sie, auf dem Handy
     nicht. Also wird hier aus der Beruehrung selbst gelesen: fast keine
     Bewegung heisst getippt, deutlich nach unten heisst gewischt.

     `preventDefault` beim Schliessen ist kein Beiwerk: sonst schickt der
     Browser nach dem Finger noch einen Klick an dieselbe Stelle, und der
     trifft dann die Seite, die unter dem geschlossenen Modal liegt. */
  let wisch = null;

  document.addEventListener('touchstart', (e) => {
    wisch = null;
    const modal = offenes(e.target);
    if (!modal || e.touches.length !== 1) return;
    wisch = {
      modal: modal,
      ziel: e.target,
      zoom: imZoom(modal),
      x: e.touches[0].clientX,
      y: e.touches[0].clientY,
    };
  }, { passive: true });

  document.addEventListener('touchend', (e) => {
    if (!wisch) return;
    const finger = e.changedTouches[0];
    const runter = finger.clientY - wisch.y;
    const quer = Math.abs(finger.clientX - wisch.x);
    const modal = wisch.modal;
    const ziel = wisch.ziel;
    const zoom = wisch.zoom;
    wisch = null;

    // Getippt: fast keine Bewegung.
    if (Math.abs(runter) < 10 && quer < 10) {
      if (ziel && ziel.closest && ziel.closest(BILDER)) return;
      e.preventDefault();
      zu(modal, false);
      return;
    }

    // Gewischt. Im Zoom schiebt der Finger das Bild, da schliesst nichts.
    if (!zoom && runter > SCHWELLE && quer < runter * SCHRAEG) {
      e.preventDefault();
      zu(modal, true);
    }
  }, { passive: false });

  document.addEventListener('touchcancel', () => { wisch = null; }, { passive: true });
})();

/* =========================================================================
   Sterne auf der Produktseite springen zu den Kundenstimmen.

   WARUM:
   Die Bewertung steht ueber dem Titel und wirkt wie ein Versprechen, dem
   man nachsehen moechte. Nachsehen heisst bisher: an der ganzen Seite
   vorbeiscrollen und hoffen. Ein Sprung dorthin ist der kuerzeste Weg
   zwischen Behauptung und Beleg.

   WIE:
   Ziel ist die Sektion, in der `.testimonials` liegt — bei uns
   „ug-stimmen", gefunden ueber die Klasse und nicht ueber die Id, damit
   ein anderer Name im Editor nichts bricht. Gesprungen wird weich und mit
   Abstand, sonst steht die erste Zeile unter dem Kopf.

   Die Sterne im Kaufblock weiter unten bekommen den Sprung auch; dort
   fuehrt er nach oben zu denselben Stimmen. Sterne INNERHALB der Stimmen
   bleiben, was sie sind.
   ========================================================================= */
(function () {
  'use strict';

  function ziel() {
    const stimmen = document.querySelector('.testimonials');
    if (!stimmen) return null;
    return stimmen.closest('[id^="shopify-section-"]') || stimmen;
  }

  function einsetzen() {
    const z = ziel();
    if (!z) return;
    if (!z.id) z.id = 'ug-stimmen';

    document.querySelectorAll('.ug-rating').forEach((sterne) => {
      if (sterne.dataset.ugSprung) return;
      if (sterne.closest('.testimonials') || sterne.closest('a')) return;
      sterne.dataset.ugSprung = '1';

      const link = document.createElement('a');
      link.className = 'ug-rating__sprung';
      link.href = '#' + z.id;
      link.title = window.ugText
        ? window.ugText('sterne_sprung', 'Kundenstimmen lesen')
        : 'Kundenstimmen lesen';
      sterne.parentElement.insertBefore(link, sterne);
      link.appendChild(sterne);
    });
  }

  /* Der Kopf klebt oben, wenn er auf „immer" steht. Dann gehoert seine
     Hoehe zum Abstand, sonst verdeckt er die Ueberschrift. */
  function abstand() {
    const kopf = document.querySelector('sticky-header[data-sticky-type="always"]');
    const hoch = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
    return 16 + (kopf && hoch ? hoch : 0);
  }

  document.addEventListener('click', (e) => {
    const link = e.target.closest('.ug-rating__sprung');
    if (!link) return;
    const z = document.querySelector(link.getAttribute('href'));
    if (!z) return;
    e.preventDefault();
    const y = z.getBoundingClientRect().top + window.scrollY - abstand();
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  });

  let uhr;
  new MutationObserver(() => { clearTimeout(uhr); uhr = setTimeout(einsetzen, 60); })
    .observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', einsetzen);
  else einsetzen();
})();

/* =========================================================================
   Cookie-Banner: Shopifys Banner, ein Griff daran.

   HIER STAND: „Cookie-Banner flach am unteren Rand, Text nur auf Wunsch."
   Shopifys Kasten wurde zu einer Zeile umgebaut, die Ueberschrift zu einem
   Knopf, der Absatz klappte dahinter weg, und die Kaufleiste rueckte um
   die gemessene Bannerhoehe nach oben. Julius hat das am 19.10.2026
   zurueckgenommen: das Banner soll als Shopify-Standard dastehen, auf dem
   Handy wie am Schirm, und angeklickt werden.

   GEBLIEBEN IST EINS: die Fuellfarbe von „Akzeptieren" wird am Knopf
   abgelesen und als `--ug-pc-ja` weitergereicht. „Ablehnen" bekommt sie in
   upgreens.css als Rahmen und Schrift, ohne Flaeche. Abgelesen statt
   festgeschrieben: wer die Bannerfarben im Admin aendert, aendert damit
   auch den Rahmen.

   WANN: Das Banner kommt nach dem Seitenaufbau, deshalb der Beobachter.
   ========================================================================= */
(function () {
  'use strict';

  /* Die Fuellung von „Akzeptieren" an „Ablehnen" weiterreichen. Einmal je
     Banner: `data-ug-fuellung` haelt fest, dass es schon geschehen ist. */
  function sehen() {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner || banner.dataset.ugFuellung) return;
    const ja = banner.querySelector('#shopify-pc__banner__btn-accept');
    if (!ja) return;
    const farbe = getComputedStyle(ja).backgroundColor;
    if (!farbe || farbe === 'rgba(0, 0, 0, 0)' || farbe === 'transparent') return;
    banner.style.setProperty('--ug-pc-ja', farbe);
    banner.dataset.ugFuellung = '1';
  }

  new MutationObserver(sehen).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sehen);
  else sehen();
})();
/* =========================================================================
   Die Frist der Charge zaehlt herunter: Tage und Stunden.

   WARUM:
   „Pre-Order-Batch 3 bis 21.10." verlangt eine Rechnung, bevor sie
   wirkt — welcher Tag ist heute, wie viel bleibt also. „endet in 3 Tagen
   und 20 Stunden" ist die Antwort selbst. Dieselbe Angabe, ein Schritt
   weniger.

   WOHER DER ZEITPUNKT KOMMT:
   Aus `data-ende` an der Zeile (snippets/ug-charge.liquid), als ISO mit
   Zeitzone. Gerechnet wird hier und nicht in Liquid: eine Seite aus dem
   Zwischenspeicher traegt sonst den Stand von vorgestern.

   WAS OHNE DIESES SKRIPT PASSIERT:
   Dann steht dort der fertige Satz mit Datum, den Liquid gerendert hat.
   Die Vorlage mit `{rest}` wird nur eingesetzt, wenn wirklich gezaehlt
   werden kann — kein halber Satz, falls ein Browser das Datum nicht
   versteht.

   WIE AUS DEM SATZ EIN TICKER WIRD:
   Zwei Zahlen mitten in einem Satz liest man als Text, nicht als Uhr.
   Deshalb steht die Zahl jetzt gross und allein, mit ihrer Einheit
   darunter — die Form, an der jeder einen Zaehler erkennt. Der Satz
   bleibt die Beschriftung darueber. Geteilt wird er an {rest}; was davor
   steht, ist die Beschriftung, was dahinter steht, haengt hinten an.

   WELCHE FELDER STEHEN:
   Tage, Stunden, Minuten. Am letzten Tag faellt das Tagesfeld weg, in der
   letzten Stunde kommen Sekunden dazu und der Takt geht auf eine Sekunde.
   So wird die Anzeige genau dann genauer, wenn es darauf ankommt — und
   drei Tage vorher laufen keine Sekunden, die niemanden angehen.

   Fuehrende Null bei Stunden, Minuten und Sekunden, keine bei den Tagen:
   „3 | 08 | 05" liest sich als Uhr, „3 | 8 | 5" als drei Zahlen.
   ========================================================================= */
(function () {
  'use strict';

  const TAKT_LANG = 10000; // Minuten laufen: alle zehn Sekunden genuegt
  const TAKT_KURZ = 1000;  // letzte Stunde: jede Sekunde

  function t(schluessel, notnagel, werte) {
    if (window.ugText) return window.ugText(schluessel, notnagel, werte);
    let text = notnagel;
    Object.keys(werte || {}).forEach((k) => { text = text.split('{' + k + '}').join(werte[k]); });
    return text;
  }

  /* „2026-10-21T18:00:00+02:00". Aeltere Browser stolpern ueber die Form
     ohne Doppelpunkt in der Zeitzone, deshalb der zweite Versuch. */
  function zeitpunkt(roh) {
    let wert = Date.parse(roh);
    if (isNaN(wert)) wert = Date.parse(String(roh).replace(/([+-]\d\d)(\d\d)$/, '$1:$2'));
    return isNaN(wert) ? null : wert;
  }

  function zwei(zahl) {
    return zahl < 10 ? '0' + zahl : String(zahl);
  }

  function felder(bleibt) {
    const sekunden = Math.floor(bleibt / 1000);
    const tage = Math.floor(sekunden / 86400);
    const stunden = Math.floor((sekunden - tage * 86400) / 3600);
    const minuten = Math.floor((sekunden - tage * 86400 - stunden * 3600) / 60);
    const sek = sekunden - tage * 86400 - stunden * 3600 - minuten * 60;

    const liste = [];
    if (tage > 0) {
      liste.push({ wert: String(tage), einheit: tage === 1
        ? t('charge_einheit_tag', 'Tag') : t('charge_einheit_tage', 'Tage') });
    }
    if (tage > 0 || stunden > 0) {
      liste.push({ wert: zwei(stunden), einheit: t('charge_einheit_stunden', 'Std') });
    }
    liste.push({ wert: zwei(minuten), einheit: t('charge_einheit_minuten', 'Min') });
    if (tage === 0 && stunden === 0) {
      liste.push({ wert: zwei(sek), einheit: t('charge_einheit_sekunden', 'Sek') });
    }
    return liste;
  }

  function bauen(zeile, vorlage, liste) {
    const teile = vorlage.split('{rest}');
    zeile.textContent = '';

    const vorne = document.createElement('span');
    vorne.className = 'ug-charge__frist-text';
    vorne.textContent = teile[0].replace(/\s+$/, '');
    zeile.appendChild(vorne);

    const uhr = document.createElement('span');
    uhr.className = 'ug-charge__uhr';
    liste.forEach((f) => {
      const zelle = document.createElement('span');
      zelle.className = 'ug-charge__zelle';
      const zahl = document.createElement('span');
      zahl.className = 'ug-charge__zahl';
      zahl.textContent = f.wert;
      const einheit = document.createElement('span');
      einheit.className = 'ug-charge__einheit';
      einheit.textContent = f.einheit;
      zelle.appendChild(zahl);
      zelle.appendChild(einheit);
      uhr.appendChild(zelle);
    });
    zeile.appendChild(uhr);

    const hinten = (teile[1] || '').replace(/^\s+/, '');
    if (hinten) {
      const rest = document.createElement('span');
      rest.className = 'ug-charge__frist-text';
      rest.textContent = hinten;
      zeile.appendChild(rest);
    }
  }

  function zeigen(zeile) {
    const ende = zeitpunkt(zeile.dataset.ende);
    const vorlage = zeile.dataset.vorlage;
    if (!ende || !vorlage) return 0;

    const bleibt = ende - Date.now();
    if (bleibt <= 0) {
      // Frist vorbei. Die Zeile hat nichts mehr zu sagen.
      zeile.hidden = true;
      return 0;
    }

    const liste = felder(bleibt);
    /* Nur anfassen, wenn sich wirklich etwas geaendert hat. Sonst baut die
       Seite jede Sekunde dieselben Felder neu. */
    const stand = liste.map((f) => f.wert + f.einheit).join('|');
    if (zeile.dataset.ugStand !== stand) {
      zeile.dataset.ugStand = stand;
      bauen(zeile, vorlage, liste);
    }
    return bleibt;
  }

  function alle() {
    let kuerzeste = 0;
    document.querySelectorAll('.ug-charge__frist[data-ende]').forEach((zeile) => {
      const bleibt = zeigen(zeile);
      if (bleibt > 0 && (kuerzeste === 0 || bleibt < kuerzeste)) kuerzeste = bleibt;
    });
    return kuerzeste;
  }

  function start() {
    if (!document.querySelector('.ug-charge__frist[data-ende]')) return;
    let takt = 0;
    let uhr = null;

    function runde() {
      const bleibt = alle();
      // In der letzten Stunde laeuft der Zaehler sekundenweise.
      const gewollt = bleibt > 0 && bleibt < 3600000 ? TAKT_KURZ : TAKT_LANG;
      if (gewollt !== takt) {
        takt = gewollt;
        if (uhr) clearInterval(uhr);
        uhr = setInterval(runde, takt);
      }
    }

    runde();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* =========================================================================
   Der Preis steht neben den Farben, nicht darunter.

   WARUM:
   Gemessen auf dem Handy: die vier Farbkreise brauchen 168px von 350.
   Rechts daneben war Platz, und der Preis stand trotzdem in einer eigenen
   Zeile darunter — 28px Hoehe fuer eine Angabe, die danebenpasst. Ueber
   dem Kaufknopf ist jede Zeile eine, die jemand wegscrollen muss.

   WIE:
   Der Preisblock wandert neben die Farbkreise, in Mottos
   `.product-form__group-wrapper` — dort, wo auch „Farbe Pfeffer" steht.
   Die Reihenfolge der drei Teile macht upgreens.css: breit stehen die
   Kreise links und der Preis rechts, „Farbe Pfeffer" darunter; wird es
   eng, rueckt „Farbe Pfeffer" neben die Kreise und der Preis bekommt die
   Zeile darunter fuer sich.

   WARUM VERSCHOBEN UND NICHT DORT GERENDERT:
   Der Preis kommt aus unserem Baustein `ug-charge`, die Farben aus Mottos
   Variantenwahl. Zwei Dateien, zwei Bloecke — zusammenkommen koennen sie
   erst im Browser.

   NACH JEDEM VARIANTENWECHSEL rendert Motto die Produktangaben neu, und
   beide Teile sind danach neue Elemente. Der Beobachter setzt den Preis
   wieder an seinen Platz.
   ========================================================================= */
(function () {
  'use strict';

  function setzen() {
    const preis = document.querySelector('.ug-charge__preis');
    const reihe = document.querySelector('.product-form__controls--colors .product-form__group-wrapper');
    if (!preis || !reihe || preis.parentElement === reihe) return;
    preis.classList.add('ug-charge__preis--neben');
    reihe.appendChild(preis);
  }

  let uhr;
  new MutationObserver(() => { clearTimeout(uhr); uhr = setTimeout(setzen, 60); })
    .observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setzen);
  else setzen();
})();
